import { USER_FORM } from "../../utils/const";

const userForm = (key: any, value: any) => {

    return {
        type: USER_FORM,
        payload: { key, value }
    }
}

export default userForm;
